import { create } from 'zustand';
import { type ExportStatus, exportStatusToTaskState } from '@/types/export';
import { TaskState } from '@/types/uploads';

interface ExportTask {
  id: string;
  label: string;
  state: TaskState;
  progress: number;
  // Set for share-scoped exports so the share progress manager reconciles each export
  // against its own share, independent of whichever share the viewer is on now.
  // Undefined for authenticated DAM exports.
  shareId?: string;
}

interface ExportStore {
  exports: Array<ExportTask>;
  addExport: (id: string, label: string, shareId?: string) => void;
  updateExport: (id: string, update: { progress: number; status: ExportStatus }) => void;
  removeExport: (id: string) => void;
}

export const useExportStore = create<ExportStore>((set) => ({
  exports: [],
  addExport: (id, label, shareId) =>
    set((prev) =>
      prev.exports.some((item) => item.id === id)
        ? prev
        : { exports: [...prev.exports, { id, label, state: TaskState.InProgress, progress: 0, shareId }] },
    ),
  updateExport: (id, { progress, status }) =>
    set((prev) => ({
      exports: prev.exports.map((item) =>
        item.id === id ? { ...item, progress, state: exportStatusToTaskState(status) } : item,
      ),
    })),
  removeExport: (id) => set((prev) => ({ exports: prev.exports.filter((item) => item.id !== id) })),
}));
